export const TRANSLATIONS = {
  SERVER_ERROR: 'Something went wrong. Please try again later',
}
